import type { CampaignPhase } from "@/lib/campaigns/black-friday/phase";
import { BLACK_FRIDAY_ANNOUNCEMENT_START } from "./config";

export function isCampaignAnnounced(now = new Date()): boolean {
	return now.getTime() >= Date.parse(BLACK_FRIDAY_ANNOUNCEMENT_START);
}

export type CampaignSurface = "teaser" | "header" | "pdp-banner" | "landing";

export function isCampaignSurfaceVisible(phase: CampaignPhase, surface: CampaignSurface): boolean {
	return phase !== "ended" || surface === "landing";
}
